import { useSelector } from "react-redux";
import _ from "lodash";
import { PMModulesEnabled, PORTAL_FULL_SEAT, PORTAL_NO_SEAT } from "helpers";
import { RootState } from "@Reducers/index";

const useUserModuleAccess = () => {
  const {
    userDetails,
    portalData,
    currentSelectedSidebarCell,
    projectSideBarIconsAndNameMapper,
    customModules = [],
  } = useSelector((state: RootState) => state);

  const isReady = Boolean(
    userDetails?._id &&
    portalData?._id &&
    (projectSideBarIconsAndNameMapper as unknown[]).some((icon: any) => icon.id == currentSelectedSidebarCell),
  );

  const getUserSeat = () => {
    if (isReady) {
      const lineItems = _.get(portalData, "subscription.lineItems", []) as Array<{ type: string; code: string }>;
      const planCodes: string[] = lineItems.filter((i: any) => i.type === "plan").map((i: any) => i.code);
      if (!planCodes.length) {
        const fallback = _.get(portalData, "subscription.plan") as string | undefined;
        if (fallback) planCodes.push(fallback);
      }

      if (!planCodes.length) return [PORTAL_FULL_SEAT];

      const userSeats = planCodes.map((code: string) => ({
        code,
        seat: _.get(userDetails, `seat.${code}`),
      }));

      const hasSeat = userSeats.some((s) => s.seat !== undefined);
      if (!hasSeat) return [PORTAL_FULL_SEAT];

      if (customModules.some((module: any) => module.name == currentSelectedSidebarCell)) {
        return [PORTAL_FULL_SEAT];
      }

      // For PM modules, check seat in PM plan(s)
      if (PMModulesEnabled.includes(currentSelectedSidebarCell)) {
        const pmPlanSeat = userSeats.find((s) => s.code.includes("PM"));
        if (pmPlanSeat && pmPlanSeat.seat !== undefined) {
          if ([PORTAL_FULL_SEAT, PORTAL_NO_SEAT].includes(pmPlanSeat.seat)) {
            return [pmPlanSeat.seat];
          }
          return [PORTAL_NO_SEAT, true];
        }
        return [PORTAL_NO_SEAT];
      }

      // For non-PM modules, use the best seat across all plans
      const bestSeat = userSeats.reduce((best: any, s) => {
        if (s.seat === PORTAL_FULL_SEAT) return PORTAL_FULL_SEAT;
        if (best === undefined) return s.seat;
        return best;
      }, undefined);

      if ([PORTAL_FULL_SEAT, PORTAL_NO_SEAT].includes(bestSeat)) {
        return [bestSeat];
      }
      return [PORTAL_FULL_SEAT];
    }
    return [null];
  };

  const [portalSeat, isPmPartialSeatPmModule] = getUserSeat();

  return {
    ready: isReady,
    portalSeat,
    isPmPartialSeatPmModule,
  };
};

export default useUserModuleAccess;
